export default "__VITE_ASSET__BvMLic4P__"